import i18n from "@config/i18n";
import { EnrollmentRestrictionOperator } from "@models/ISchema";

export const getRestrictionOperators = () => {
  return [
    {
      label: i18n.t(
        `group-restrictions.manage-restrictions.form.conditions.${EnrollmentRestrictionOperator.In}`,
      ),
      value: EnrollmentRestrictionOperator.In,
    },
    {
      label: i18n.t(
        `group-restrictions.manage-restrictions.form.conditions.${EnrollmentRestrictionOperator.Nin}`,
      ),
      value: EnrollmentRestrictionOperator.Nin,
    },
  ];
};

/**
 * Dynamically extracts the code and the name/label from a restriction object.
 * Inspects the object keys searching for standard API naming patterns (e.g. `campusCode` / `campusName`).
 * This provides automatic support for new restriction types without needing to update this helper.
 *
 * @param {any} restriction - The restriction object (e.g. CustomModelValue, Modality, Program, Campus, etc.).
 * @returns {{ code: string; name: string }} An object with the resolved `code` and `name` properties.
 */
export const getRestrictionValue = (restriction: any) => {
  if (!restriction) return { code: "", name: "" };

  // Dynamically find the key for the code (e.g. exactly "code" or ending with "Code")
  const codeKey = Object.keys(restriction).find(key => key === "code" || key.endsWith("Code"));

  // Dynamically find the key for the name/label (e.g. exactly "name", "label", or ending with "Name"/"Label")
  const nameKey = Object.keys(restriction).find(
    key => key === "name" || key === "label" || key.endsWith("Name") || key.endsWith("Label"),
  );

  return {
    code: codeKey ? restriction[codeKey] ?? "" : "",
    name: nameKey ? restriction[nameKey] ?? "" : "",
  };
};
